const TRUST_ITEMS = [
  { icon: 'ri-shield-check-line', text: '15+ Years of Excellence' },
  { icon: 'ri-group-line', text: 'Trusted by Farmers & Distributors' },
  { icon: 'ri-leaf-line', text: 'ISO Quality Standards' },
  { icon: 'ri-map-pin-line', text: 'Manufactured in Pakistan' },
  { icon: 'ri-award-line', text: '500+ Premium Products' },
];

export default function TrustStrip() {
  return (
    <div
      className="w-full py-5 border-y border-white/5 overflow-hidden"
      style={{ background: 'linear-gradient(90deg, #0E1218 0%, #141F30 50%, #0E1218 100%)' }}
    >
      <div className="flex items-center gap-16 overflow-x-auto no-scrollbar px-8 md:justify-center">
        {TRUST_ITEMS.map((item, i) => (
          <div key={i} className="flex items-center gap-2.5 flex-shrink-0">
            <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
              <i className={`${item.icon} text-accent text-base`} />
            </div>
            <span className="text-text-soft text-sm whitespace-nowrap font-medium">{item.text}</span>
            {i < TRUST_ITEMS.length - 1 && (
              <span className="ml-12 text-white/10 hidden md:block">|</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
